/*
 * State: properties to store
 */
const state = {
    notificationDisplayed: false,
    text: "",
    type: ""
};

/*
 * Mutations (Setters): Setters of properties defined in state
 */
const mutations = {
    SHOW_NOTIFICATION(state, { text, type }) {
        state.notificationDisplayed = true;
        state.text = text;
        state.type = type;
    },

    RESET_NOTIFICATION(state) {
        state.notificationDisplayed = false;
        state.text = "";
        state.type = "";
    }
};

/*
 * Getters: Getters of properties defined in state
 */
const getters = {
    /*
     * Getter for notificationDisplayed
     */
    notificationDisplayed(state) {
        return state.notificationDisplayed;
    },

    /*
     * Getter for text
     */
    getNotificationText(state) {
        return state.text;
    },

    /*
     * Getter for type
     */
    getNotificationType(state) {
        return state.type;
    }
};

/*
 * Actions: List of methods to fetch, update or delete data
 */
const actions = {
    sendNotification({ commit }, notifData) {
        commit("SHOW_NOTIFICATION", notifData);
    },

    resetNotification({ commit }) {
        commit("RESET_NOTIFICATION", {});
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
